import React, { ReactNode, useContext } from "react";
import { useTranslation } from "react-i18next";
import StepProgress from "./step-progress";
import AuthContext from "../auth-context";

export interface ISignUpLayoutProps {
  children: ReactNode;
  step: number;
  type?: number;
  steps: number[];
  agentData?: AgentData;
}

interface AgentData {
  name: string | null;
  code: number | null;
}

const SignUpLayout: React.FC<ISignUpLayoutProps> = ({
  children,
  step,
  type,
  steps,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp" });
  const context = useContext(AuthContext);
  const agentData = context.userData;
  return (
    <div className="container mt-5 mx-auto">
      <div className="main-section xs:p-10 lg:p-10 xl:p-20 p-20 rounded-xl pb-6">
        <div className="top-nav-section flex justify-between items-center">
          <a
            href="https://sepanta.com"
            className="login-logo mx-1 text-grey-d3 items-center"
          >
            <img
              alt="logo"
              className="logo mobile w-28"
              src="https://c.sepanta.com/i1/Logos/SepantaLogo.png"
            />
            <span className="mainTitle">سپنتا</span>
          </a>
        </div>

        <div className="signup-form-head-section xs:mb-0 mb-10 flex flex-col flex-row-reverse justify-center p-10">
          <div>
            <h3 className="head-title text-center justify-center d-block">
              {type === 2 ? t("Ngn Registration") : t("Service Registeration")}
            </h3>
          </div>
          {agentData?.name && agentData?.code && (
            <div>
              <h2 className="head-title text-center justify-center d-block">
                {`${agentData!.name} (کد نمایندگی ${agentData!.code})`}
              </h2>
            </div>
          )}
        </div>

        <StepProgress step={step} type={type} steps={steps} />
        {children}
      </div>
    </div>
  );
};
export default SignUpLayout;
